module.exports = __webpack_public_path__ + "anastasia.png?6f3fa4ff3bd474d540e7a42d82314ea5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anastasia.png
// module id = 371
// module chunks = 0